//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { cloneDeep, isEmpty, isUndefined, isEqual, find, isNull } from 'lodash'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { distributionGroupRepositoryActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Theme from '../../theme/theme'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import { uriList } from '../../routings/settings/RouteList'
import Button from '../../components/Ui/Buttons'
import Tooltip from '../../components/Tooltip/Tooltip'
import { DistributionGroupRepositoryStatus, DistributionGroupRepositoryImg, DistributionGroupRepositoryDescription } from './Components'
import UseCheckAll from '../../hooks/UseCheckAll'
import Modals from '../../components/Modals'
import { TextModal, TableHeaderCreateButton } from '../../theme/GlobalCss'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'
import StringFormatter from '../../helpers/StringFormatter'
import TableTitle from '../../components/Table/components/TableTitle'
import 'react-loading-skeleton/dist/skeleton.css'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const DistributionGroupWrapper = styled.div`
	position: relative;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalWrapperBottom = styled(TextModalWrapper)`
	margin-bottom: 15px;
`
const TextModalCustom = styled.div`
	padding: 0;
`
const TextModalPrimary = styled(TextModal)`
	color: ${(props) => props.theme.colors.primary};
	padding: 0;
	margin: 2px 5px;
`
const TextModalRed = styled(TextModal)`
	color: ${(props) => props.theme.colors.error};
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	justify-content: space-between;
	margin-left: 5px;
	margin-right: 5px;
	width: 100%;
`
//////STYLED//////

const DistributionGroupRepository = () => {
	const {
		user,
		translations,
		distributionGroupRepository,
		distributionGroupRepositoryFilters,
		userRolePrivileges,
		userKioskPerimeter,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			distributionGroupRepository: state.distributionGroupRepository,
			distributionGroupRepositoryFilters: state.distributionGroupRepository.header,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			userRolePrivileges: state.user.identity.rolePrivileges,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)
	const actionsdistributionGroupRepository = bindActionCreators(distributionGroupRepositoryActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	let history = useHistory()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'createdDate', nameDir: 'desc' })
	const [row, setRow] = useState({})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modal
	const [showModalActivate, setShowModalActivate] = useState(false)
	const [showModalDelete, setShowModalDelete] = useState(false)
	const [showDeactivateModal, setShowDeactivateModal] = useState(false)

	// Columns
	const [columns, setColumns] = useState([])

	// Config
	const [configTableTitle, setConfigTableTitle] = useState({
		name: '',
		paging: {
			fnSendTo: (paging) => handlePagingDistribution(paging),
		},
		actions: {
			// we comment this part a code according to the feature [76]
			/* 	dateLists:[
				() => (
					<Fragment>
					<label style={{color:Theme.colors.table.body.text, marginRight: '10px', lineHeight:'32px'}}>{translations['page__global__admin__header__transactionDate']} :</label>
					<DatePickerCreationIcon
						onClick={dateCreationOpenDateModalHandler}
					/>
					<DatePickerFilterLabel>
						<span>{translations['page__global__admin__header_datePicker_from']} {(isEqual(dateCreationStateDate.date.startDate,{})) ? moment(new Date()).subtract(2,'weeks').format("DD/MM/YYYY") : moment(dateCreationStateDate.date.startDate).format("DD/MM/YYYY")}</span>
						<span>{translations['page__global__admin__header_datePicker_to']} {(isEqual(dateCreationStateDate.date.endDate,{})) ? moment(new Date()).format("DD/MM/YYYY") : moment(dateCreationStateDate.date.endDate).format("DD/MM/YYYY")}</span>
					</DatePickerFilterLabel>
					</Fragment>
				)
			] */
		},
	})

	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleModal = () => {
		setShowModalActivate(false)
		setShowModalDelete(false)
		setShowDeactivateModal(false)
	}

	const hanldeModalActivate = (row) => {
		setShowModalActivate(true)
		if (showModalActivate) {
			setShowModalActivate(false)
		}
		setRow(row)
	}

	const handleActiveItem = (idItem) => {
		// Changing back call, to use those available for timeline page
		//actionsdistributionGroupRepository.postActiveItem(idItem)
		actionsdistributionGroupRepository.postActiveItem(idItem, 'Active')
		handleModal()
	}

	const hanldeModalDelete = (row) => {
		setShowModalDelete(true)
		if (showModalDelete) {
			setShowModalDelete(false)
		}
		setRow(row)
	}

	const handleModalDeactivate = (row) => {
		setShowDeactivateModal(true)
		if (showDeactivateModal) {
			setShowDeactivateModal(false)
		}
		setRow(row)
	}

	const handleDeleteItem = (idItem) => {
		// Changing back call, to use those available for timeline page
		//actionsdistributionGroupRepository.postDeleteItem(idItem)
		actionsdistributionGroupRepository.postDeleteItem(idItem, 'Deleted')
		handleModal()
	}

	const handleDeactivateItem = (idItem) => {
		actionsdistributionGroupRepository.postDeactivateItem(idItem, 'Unactive')
		handleModal()
	}

	const handleViewItems = (row) => {
		actionsdistributionGroupRepository.setItemId(row.itemId)
		history.push(`${uriList.distributionItem}${uriList.distributionGroupRepositorytDetail}/${row.itemId}`)
	}

	const handleEditItem = (row) => {
		history.push(`${uriList.article}${uriList.articleEdit}/${row.itemId}`)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val.trim())
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value.trim())
		actionsColumns.setIsSearchfieldUpdated(true)
	}
	const handlePagingDistribution = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'createdDate',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsdistributionGroupRepository.postDistributionGroup(handleFilterSend(), pg)
	}
	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)

		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'createdDate', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsdistributionGroupRepository.postDistributionGroup(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}

		filtersOut = { ...searchFieldUpdated, ...filtersIn }

		return {
			...filtersOut,
			withFilters: true,
			// we comment this part a code according to the feature [76]
			/* 	"datesRange" : 
			{
				// Dummy dates 
				"dateStart" :		dateCreationStateDate.date.startDate,
				"dateEnd" : 		dateCreationStateDate.date.endDate,
			}, */
		}
	}
	const handleLifeCycleView = (row) => {
		history.push(`${uriList.article}${uriList.articleLife}/${row.itemId}`)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'articleReferential_productImage',
				dataHook: 'itemPicture',
				headerName: translations['page__itemReferential__referential__tableHeader_itemPicture'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'picture',
				component: DistributionGroupRepositoryImg,
			},
			{
				columnReferential: 'articleReferential_item',
				dataHook: 'itemCode',
				headerName: translations['page__itemReferential__referential__tableHeader_itemCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'label',
			},
			{
				columnReferential: 'articleReferential_referentialName',
				dataHook: 'itemRefLabel',
				headerName: translations['page__itemReferential__referential__tableHeader_itemRefName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelToDisplay',
			},
			{
				columnReferential: 'articleReferential_state',
				dataHook: 'itemStatus.translationKey',
				headerName: translations['page__itemReferential__referential__tableHeader_itemState'],
				sortable: true,
				isAuthorize: true,
				component: DistributionGroupRepositoryStatus,
				sortableId: 'status.description',
			},
			{
				columnReferential: 'articleReferential_creationDate',
				dataHook: 'creationDate',
				headerName: translations['page__itemReferential__referential__tableHeader_creationDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.creationDate) ? moment(props.row.creationDate).format('DD/MM/YYYY') : '-'),
				sortableId: 'createdDate',
			},
			{
				columnReferential: 'articleReferential_activationDate',
				dataHook: 'activationDate',
				headerName: translations['page__itemReferential__referential__tableHeader_activationDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.activationDate) ? moment(props.row.activationDate).format('DD/MM/YYYY') : '-'),
				sortableId: 'dateEnabled',
			},
			{
				columnReferential: 'articleReferential_family',
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__itemReferential__referential__tableHeader_itemFamily'],
				toTranslate: true,
				sortable: true,
				isAuthorize: true,
				sortableId: 'family.label',
			},
			{
				columnReferential: 'articleReferential_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['page__itemReferential__referential__tableHeader_itemBrand'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'brand.label',
			},
			{
				columnReferential: 'articleReferential_description',
				dataHook: 'withDescription.translationKey',
				headerName: translations['page__itemReferential__referential__tableHeader_itemDescription'],
				toTranslate: true,
				sortable: true,
				isAuthorize: true,
				component: DistributionGroupRepositoryDescription,
				sortableId: 'description',
			},
			{
				columnReferential: 'articleReferential_consignation',
				dataHook: 'withConsignment.translationKey',
				headerName: translations['page__itemReferential__referential__tableHeader_consignationEnable'],
				toTranslate: true,
				sortable: true,
				isAuthorize: true,
				sortableId: 'withDeposit',
			},
			{
				columnReferential: 'articleReferential_distributorGrp',
				dataHook: 'groupDistriLabel',
				headerName: translations['page__itemReferential__referential__tableHeader_distributionGroup'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'distributionGroup.company.labelToDisplay',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				tooltipPart: 'repository',
				rest: {
					paperActionsList: [
						{
							name: translations['page__itemReferential__referential__tableAction_seeDetail'],
							translationKey: 'tooltip__admin__itemReferential__tableAction__itemDetail',
							clickAction: (row) => {
								handleViewItems(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[0])),
							//iconDef: view,
						},
						{
							name: translations['page__itemReferential__referential__tableAction_modifyItem'],
							translationKey: 'tooltip__admin__itemReferential__tableAction__updateItem',
							clickAction: (row) => {
								handleEditItem(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[0])),
							//iconDef: edit,
						},
						{
							name: translations['page__itemRef__timeline_tab'],
							translationKey: 'tooltip__admin__itemReferential__tableAction__itemDetail',
							clickAction: (row) => {
								handleLifeCycleView(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[0])), // voir le priv renvoyé
							//icon: ItemLife,
						},
						{
							name: translations['page__itemReferential__referential__tableAction_activeItem'],
							clickAction: (row) => {
								hanldeModalActivate(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[0])) &&
								row.canActive === true,
						},
						{
							name: translations['page__itemReferential__referential__tableAction_deleteItem'],
							clickAction: (row) => {
								hanldeModalDelete(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[0])) &&
								row.canDelete === true,
						},
						{
							name: "Désactiver l'article",
							clickAction: (row) => {
								handleModalDeactivate(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[0])) &&
								row.canDisable === true,
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 1,
		labelPageTable: 'articleReferential',
	}
	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(distributionGroupRepository) && !isUndefined(distributionGroupRepository)) {
			cfg.paging = {
				totalElements: distributionGroupRepository.paging.totalElements,
				totalPages: distributionGroupRepository.paging.totalPages,

				fnSendTo: (paging) => handlePagingDistribution(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [distributionGroupRepository])

	useEffect(() => {
		if (isUndefined(searchValue)) return
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === distributionGroupRepository) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		if (!isEmpty(translations)) {
			const filtersCp = cloneDeep(distributionGroupRepositoryFilters)
			//filtersCp.withFilters = true
			setFilters(filtersCp)
			setPrevFilter(filtersCp)
			actionsColumns.setIsSearchfieldUpdated(false)
		}
	}, [distributionGroupRepositoryFilters, translations])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__itemReferential__referential__title']
		cfg.paging = {
			totalElements: distributionGroupRepository.paging.totalElements,
			totalPages: distributionGroupRepository.paging.totalPages,
			fnSendTo: (paging) => handlePagingDistribution(paging),
		}
		cfg.actions = {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_brandLabel']}
					data={filters.filtersSelection?.itemBrand.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemBrand'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemFamily']}
					data={filters.filtersSelection?.itemFamily.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemFamily'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemState']}
					data={filters.filtersSelection?.itemStatus.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemStatus'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_distributoinGroup']}
					data={filters.filtersSelection?.distributionGroup.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'distributionGroup'}
				/>
			),
		]
		// we comment this part a code according to the feature [76]
		/* 	cfg.actions.dateLists = [
			() => (
				<Fragment>
				<label style={{color:Theme.colors.table.body.text, marginRight: '10px', lineHeight:'32px'}}>{translations['common__fastFilter_creationDate']} :</label>
				<DatePickerCreationIcon
					onClick={dateCreationOpenDateModalHandler}
				/>
				<DatePickerFilterLabel>
					<span>{translations['page__global__admin__header_datePicker_from']} {(isEqual(dateCreationStateDate.date.startDate,{})) ? moment(new Date()).subtract(2,'weeks').format("DD/MM/YYYY") : moment(dateCreationStateDate.date.startDate).format("DD/MM/YYYY")}</span>
					<span>{translations['page__global__admin__header_datePicker_to']} {(isEqual(dateCreationStateDate.date.endDate,{})) ? moment(new Date()).format("DD/MM/YYYY") : moment(dateCreationStateDate.date.endDate).format("DD/MM/YYYY")}</span>
				</DatePickerFilterLabel>
				</Fragment>
			)
		] */

		setConfigTableTitle(cfg)
	}, [translations, filters, prevFilter /* dateCreationStateDate */])

	useEffect(() => {
		let cfgCp = cloneDeep(configTable)

		cfgCp.export = {
			privilege: userPrivileges.export[0],
			url: urlExport[4],
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				//datesRange: {dateEnd:dateCreationStateDate.date.endDate, dateStart:dateCreationStateDate.date.startDate},
				searchField: searchValue,
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters, prevFilter])

	// we comment this part a code according to the feature [76]
	/* useEffect(() => {
		if(dateCreationStateDate.showModal)
		{
			actionsdistributionGroupRepository.postDistributionGroup( handleFilterSend(), paging )
		}
	},[dateCreationShowModal])  */

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				searchFieldUpdated: false,

				// we comment this part a code according to the feature [76]
				/* "datesRange" : 
				{
					// Dummy dates 
					"dateStart" :		moment().subtract(2, "weeks").toDate(),
					"dateEnd" : 		moment().add(1, 'minutes').toDate(),
				}, */
			}
			actionsdistributionGroupRepository.postDistributionGroup(filtersCp)
			actionsColumns.setColumns([])
			setFilters(filtersCp)
		}
	}, [distributionGroupRepository, translations])

	// On deleting article
	useEffect(() => {
		if (distributionGroupRepository.deleteSuccess) {
			actionsdistributionGroupRepository.postDistributionGroup(handleFilterSend(), paging)
		}
	}, [distributionGroupRepository.deleteSuccess])

	// On activating / deactivating article
	useEffect(() => {
		if (distributionGroupRepository.update) {
			actionsdistributionGroupRepository.postDistributionGroup(handleFilterSend(), paging)
		}
	}, [distributionGroupRepository.update])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsdistributionGroupRepository.postDistributionGroup(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		return function cleanUp() {
			actionsdistributionGroupRepository.resetDistributionGroup()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={distributionGroupRepository.items}
				inputConfig={configTable}
				isLoading={distributionGroupRepository.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsdistributionGroupRepository.postDistributionGroup}
			/>
		)
	}, [distributionGroupRepository, columns, configTable, translations, paging])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{/* MODAL ACTIVATION ARTICLE */}
			{row.canActive && (
				<Modals title={translations['modal__activeItem__title']} showModal={showModalActivate} icon={true} closeModalHandler={handleModal}>
					<TextTopWrapper>
						<TextModalWrapper>
							<TextModalCustom>{translations['modal__activeItem__description_start']}</TextModalCustom>
							<TextModalPrimary>{`[${row.itemRefLabel}]`}</TextModalPrimary>
							<TextModalCustom>{translations['modal__activeItem__description_mid']}</TextModalCustom>
						</TextModalWrapper>
						<TextModalWrapper>
							<TextModalCustom>{translations['modal__activeItem__description_end']}</TextModalCustom>
						</TextModalWrapper>
					</TextTopWrapper>
					<TextModalWrapperBottom>
						<TextModalRed>{translations['modal__activeItem__warning']}</TextModalRed>
					</TextModalWrapperBottom>

					<ButtonWrapper>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							img={Cancel}
							margin="true"
						/>
						<Button
							actionHandler={() => handleActiveItem(row.itemId)}
							text={translations['modal__activeItem__button_active']}
							bgColor={Theme.colors.validation}
							img={Validation}
							width={250}
							//disabled={isEqual(rgpdData,{}) || isEmpty(rgpdData)}
						/>
					</ButtonWrapper>
				</Modals>
			)}
			{/* MODAL DEACTIVATION ARTICLE */}
			{
				// Will be implemented by back-end
				//row.canDisable &&
				<Modals
					showModal={showDeactivateModal}
					closeModalHandler={handleModal}
					level="error"
					icon={true}
					title={translations['modal__itemRef__timeline_action_deactivateNow_title']}
					width={555}
				>
					<TextTopWrapper>
						<TextModalWrapper>
							<TextModalCustom
								dangerouslySetInnerHTML={{
									__html: StringFormatter.ResponseMessageParser(
										translations['modal__itemRef__timeline_action_deactivateNow_message'],
										[`<span style="color:	${Theme.colors.primary}" > [${row.itemRefLabel}] </span>`]
									),
								}}
							></TextModalCustom>
						</TextModalWrapper>
					</TextTopWrapper>

					<ButtonWrapper>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						<Button
							actionHandler={() => handleDeactivateItem(row.itemId)}
							text={translations['modal__itemRef__timeline_action_deactivateNow_buttons_validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
							width={250}
						/>
					</ButtonWrapper>
				</Modals>
			}
			{/* MODAL SUPPRESSION ARTICLE */}
			{row.canDelete && (
				<Modals
					title={translations['modal__deleteItem__title']}
					level="error"
					showModal={showModalDelete}
					icon={true}
					maxWidth={555}
					closeModalHandler={handleModal}
				>
					<TextModalWrapper>
						<TextModalCustom>{translations['modal__deleteItem__description_start']}</TextModalCustom>
						<TextModalPrimary>{`[${row.itemRefLabel}]`}</TextModalPrimary>
						<TextModalCustom>{translations['modal__deleteItem__description_end']}</TextModalCustom>
					</TextModalWrapper>

					<TextModalWrapperBottom>
						<TextModalRed>{translations['modal__deleteItem__warning']}</TextModalRed>
					</TextModalWrapperBottom>

					<ButtonWrapper>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							img={Cancel}
							margin="true"
						/>
						<Button
							actionHandler={() => handleDeleteItem(row.itemId)}
							text={translations['modal__deleteItem__button_delete']}
							bgColor={Theme.colors.validation}
							img={Validation}
							//disabled={isEqual(rgpdData,{}) || isEmpty(rgpdData)}
							width={292}
						/>
					</ButtonWrapper>
				</Modals>
			)}

			{/* TABLEAU */}
			<DistributionGroupWrapper>
				{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[0])) && (
					<Tooltip translationsKey={'tooltip__admin__itemReferential__createProduct'} tooltipId={'distributionGroupCreateItem'}>
						<TableHeaderCreateButton to={`${uriList.article}${uriList.articleCreate}`} />
					</Tooltip>
				)}
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</DistributionGroupWrapper>
		</Fragment>
	)
}

DistributionGroupRepository.propTypes = {}

DistributionGroupRepository.defaultPropTypes = {}

export default DistributionGroupRepository
